const _postBody = async (endpoint, body) => {
    const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
    }).catch((error) => {
        return false;
    });
    const data = await res;
    return data;
}
export default _postBody


